import { render, staticRenderFns } from "./UserEditPassword.vue?vue&type=template&id=518dbfb6&scoped=true"
import script from "./UserEditPassword.vue?vue&type=script&lang=js"
export * from "./UserEditPassword.vue?vue&type=script&lang=js"
import style0 from "./UserEditPassword.vue?vue&type=style&index=0&id=518dbfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518dbfb6",
  null
  
)

export default component.exports